import { backgroundStyles } from './compound-settings';
import { prefixBackgroundStyle } from './compound-settings/background-styles';
import timeZone from '../utils/timeZone';

export default {
    default: [],
    section: [
        {
            hoverControl: false,
            label: 'Section Background',
            modules: ['settings/activeBgStyle', ...backgroundStyles],
        },
        {
            hoverControl: false,
            label: 'Section Frame',
            modules: [
                {
                    path: 'frames',
                    content: { template: 'SectionFrame' },
                },
            ],
        },
        {
            hoverControl: false,
            label: 'Width & Height',
            modules: [
                {
                    path: 'style/width',
                    content: { info: 'Set the width of the section' },
                },
                'style/maxWidth',
                // TODO: section alignment
                // 'wrapper/margin',
                'style/minHeight',
                'style/height',
                'style/maxHeight',
            ],
        },
    ],
    column: [
        {
            hoverControl: false,
            label: 'Column Option',
            modules: [
                {
                    path: 'attr/__class__columnSize',
                    content: {
                        isResponsible: true,
                        template: 'ColumnSize',
                        label: 'Select Column Size',
                    },
                },
            ],
        },
        {
            hoverControl: false,
            label: 'Content Alignment',
            modules: [
                {
                    path: 'style/justifyContent',
                    content: {
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'normal',
                        label: 'Vertical Alignment',
                        options: [
                            { value: 'normal', label: 'Normal' },
                            { value: 'flex-start', label: 'Top' },
                            { value: 'center', label: 'Center' },
                            { value: 'flex-end', label: 'Bottom' },
                        ],
                    },
                },
                {
                    path: 'style/textAlign',
                    content: {
                        isResponsible: true,
                        label: 'Horizontal Alignment',
                    },
                },
            ],
        },
        {
            label: 'Background',
            modules: [
                {
                    path: 'settings/activeBgStyle',
                    content: {
                        visibleOn: ['normal', 'hover'],
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'color',
                        label: 'Background Style',
                        options: [
                            { label: 'Color', value: 'color' },
                            { label: 'Gradient', value: 'gradient' },
                            { label: 'Image', value: 'image' },
                        ],
                    },
                },
                ...backgroundStyles,
            ],
        },
    ],
    row: [
        {
            hoverControl: false,
            label: 'Row / Container Option',
            modules: [
                {
                    path: 'wrapper/width',
                    content: {
                        label: 'Row / Container Width',
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: '',
                        options: [
                            { label: 'Default Width', value: '' },
                            { label: '100% Width', value: '100%' },
                        ],
                    },
                },
                {
                    path: 'style/alignItems',
                    content: {
                        label: 'Columns Height',
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'stretch',
                        options: [
                            { label: 'Auto', value: 'flex-start' },
                            { label: 'Equal Height', value: 'stretch' },
                        ],
                    },
                },
                {
                    path: 'settings/columnGap',
                    content: {
                        max: 500,
                        defaultUnit: 'px',
                        template: 'Range',
                        isResponsible: true,
                        label: 'Column Gap',
                    },
                },
                {
                    path: 'settings/reverseColumn',
                    content: {
                        onLabel: 'ON',
                        offLabel: 'OFF',
                        onValue: true,
                        offValue: false,
                        template: 'Switch',
                        defaultValue: false,
                        label: 'Reverse Column Stacking (Responsive)',
                    },
                },
                // {
                //     path: 'style/alignItems',
                //     conditions: ['style/alignItems', '!==', 'stretch'],
                //     content: {
                //         label: 'Vertical Alignment',
                //         template: 'Tab',
                //         inputType: 'boxed',
                //         defaultValue: '',
                //         options: [
                //             { label: 'Top', value: 'flex-start' },
                //             { label: 'Center', value: 'center' },
                //             { label: 'Bottom', value: 'flex-end' },
                //         ],
                //     },
                // },
            ],
        },
        {
            hoverControl: false,
            label: 'Row Background',
            modules: ['settings/activeBgStyle', ...backgroundStyles],
        },
    ],
    heading: [
        {
            hoverControl: false,
            label: 'Title Settings',
            modules: [
                'titleType',
                'content',
                // {
                //     path: 'none',
                //     content: {
                //         label: 'Text Editing',
                //         template: 'HelpText',
                //         message: `<ul>
                //             <li>Click on the text to modify content using our rich text editor</li>
                //             <li>Font family can be changed from "Global Styles"</li>
                //         </ul>`,
                //     },
                // },
                // mark : dynamic items
                {
                    path: 'settings/dynamicText/_enabled',
                    content: {
                        onLabel: 'ON',
                        offLabel: 'OFF',
                        onValue: true,
                        offValue: false,
                        template: 'Switch',
                        defaultValue: false,
                        label: 'Dynamic Text',
                    },
                    resetDep: false,
                    dependentsValue: {
                        'dynamicText/options/loop': true,
                        'dynamicText/options/typeSpeed': '40',
                        'dynamicText/options/backSpeed': '40',
                        'dynamicText/items': [
                            {
                                id: 'hfgvo35u',
                                content: 'Lorem ipsum',
                            },
                            {
                                id: 'hfgvo35i',
                                content: 'dolor sit amet',
                            },
                            {
                                id: 'hfgvo35j',
                                content: 'consectetur adipiscing',
                            },
                        ],
                    },
                },
                {
                    hoverControl: false,
                    group: true,
                    label: 'Dynamic Text Items',
                    conditions: ['settings/dynamicText/_enabled', '===', true],
                    modules: [
                        {
                            template: 'MigrateDynamicTextItems',
                        },
                        {
                            path: 'dynamicText/items',
                            template: 'DraggableItems',
                            modules: [
                                {
                                    key: 'content',
                                    content: {
                                        type: 'simple',
                                        height: '150px',
                                        defaultValue: '',
                                        label: 'Dynamic Text',
                                        template: 'RichTextEditor',
                                    },
                                },
                            ],
                        },
                    ],
                },
                // mark : dynamic options
                {
                    hoverControl: false,
                    label: 'Dynamic Options',
                    group: true,
                    conditions: ['settings/dynamicText/_enabled', '===', true],
                    modules: [
                        {
                            path: 'dynamicText/options/typeSpeed',
                            content: {
                                template: 'Range',
                                allowedUnits: [''],
                                label: 'TypeSpeed',
                            },
                        },
                        {
                            path: 'dynamicText/options/backSpeed',
                            content: {
                                template: 'Range',
                                allowedUnits: [''],
                                label: 'BackSpeed',
                            },
                        },
                        {
                            path: 'dynamicText/options/loop',
                            content: {
                                onLabel: 'ON',
                                offLabel: 'OFF',
                                onValue: true,
                                offValue: false,
                                template: 'Switch',
                                defaultValue: true,
                                label: 'Loop',
                            },
                        },
                        {
                            path: 'dynamicText/options/cursorChar',
                            content: {
                                onLabel: 'Visible',
                                offLabel: 'Hidden',
                                onValue: true,
                                offValue: false,
                                template: 'Switch',
                                defaultValue: true,
                                label: 'Cursor Visibility',
                            },
                        },
                    ],
                },
            ],
        },
        {
            hoverControl: false,
            label: 'Title Styles',
            modules: [
                'style/textAlign',
                'style/color',
                'style/fontSize',
                {
                    hoverable: false,
                    isResponsible: true,
                    template: 'FontSpaceLH',
                    modules: ['style/lineHeight', 'style/letterSpacing'],
                },
                'style/textTransform',
                'style/textDecoration/type',
                {
                    modules: [
                        'style/textDecoration/style',
                        'style/textDecoration/color',
                    ],
                    conditions: [
                        ['style/textDecoration/type', '!=', null],
                        '&&',
                        ['style/textDecoration/type', '!==', 'none'],
                    ],
                },
                'style/textShadow/_enabled',
                {
                    conditions: ['style/textShadow/_enabled', '===', true],
                    modules: [
                        {
                            hoverable: true,
                            isResponsible: true,
                            label: 'Shadow Offset & Blur',
                            modules: [
                                'style/textShadow/x',
                                'style/textShadow/y',
                                'style/textShadow/blur',
                            ],
                        },
                        'style/textShadow/color',
                    ],
                },
                // mark : dynamic style
                {
                    hoverControl: false,
                    group: true,
                    label: 'Dynamic Text Styles',
                    conditions: ['settings/dynamicText/_enabled', '===', true],
                    modules: [
                        'dynamicText/style/color',
                        'dynamicText/style/textDecoration/type',
                        {
                            modules: [
                                'dynamicText/style/textDecoration/style',
                                'dynamicText/style/textDecoration/color',
                            ],
                            conditions: [
                                [
                                    'dynamicText/style/textDecoration/type',
                                    '!=',
                                    null,
                                ],
                                '&&',
                                [
                                    'dynamicText/style/textDecoration/type',
                                    '!==',
                                    'none',
                                ],
                            ],
                        },
                        {
                            modules: [
                                {
                                    path: 'settings/activeBgStyle',
                                    content: {
                                        visibleOn: ['normal', 'hover'],
                                        template: 'Tab',
                                        inputType: 'boxed',
                                        defaultValue: 'color',
                                        label: 'Background Style',
                                        options: [
                                            { label: 'Color', value: 'color' },
                                            {
                                                label: 'Gradient',
                                                value: 'gradient',
                                            },
                                        ],
                                    },
                                },
                                ...prefixBackgroundStyle('dynamicText/style'),
                            ],
                        },
                    ],
                },
            ],
        },
        {
            label: 'Title Background',
            modules: [
                {
                    path: 'settings/activeBgStyle',
                    content: {
                        visibleOn: ['normal', 'hover'],
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'color',
                        label: 'Background Style',
                        options: [
                            { label: 'Color', value: 'color' },
                            { label: 'Gradient', value: 'gradient' },
                        ],
                    },
                },
                ...backgroundStyles,
            ],
        },
        {
            hoverControl: false,
            label: 'Title Link',
            modules: ['wrapper/attr/href', 'wrapper/attr/target'],
        },
    ],
    text: [
        {
            hoverControl: false,
            label: 'Text Settings',
            modules: [
                // {
                //     path: 'none',
                //     content: {
                //         label: 'Text Editing',
                //         template: 'HelpText',
                //         message: `<ul>
                //             <li>Click on the text to modify content using our rich text editor</li>
                //             <li>Font family can be changed from "Global Styles"</li>
                //         </ul>`,
                //     },
                // },
                'content',
                'style/textAlign',
                'style/color',
                'style/fontSize',
                {
                    hoverable: false,
                    isResponsible: true,
                    label: 'Spacing & Line Height',
                    template: 'FontSpaceLH',
                    modules: ['style/lineHeight', 'style/letterSpacing'],
                },
                'style/textTransform',
                'style/textDecoration/type',
                {
                    conditions: [
                        ['style/textDecoration/type', '!=', null],
                        '&&',
                        ['style/textDecoration/type', '!==', 'none'],
                    ],
                    modules: [
                        'style/textDecoration/style',
                        'style/textDecoration/color',
                    ],
                },
                'style/textShadow/_enabled',
                {
                    conditions: ['style/textShadow/_enabled', '===', true],
                    modules: [
                        {
                            hoverable: true,
                            isResponsible: true,
                            label: 'Shadow Offset & Blur',
                            modules: [
                                'style/textShadow/x',
                                'style/textShadow/y',
                                'style/textShadow/blur',
                            ],
                        },
                        'style/textShadow/color',
                    ],
                },
            ],
        },
        {
            label: 'Text Background',
            modules: [
                {
                    path: 'settings/activeBgStyle',
                    content: {
                        visibleOn: ['normal', 'hover'],
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'color',
                        label: 'Background Style',
                        options: [
                            { label: 'Color', value: 'color' },
                            { label: 'Gradient', value: 'gradient' },
                        ],
                    },
                },
                ...backgroundStyles,
            ],
        },
    ],
    iconText: [
        {
            hoverControl: false,
            label: 'Icon Content',
            modules: [
                {
                    path: 'content',
                    content: { template: 'Input', inputType: 'input' },
                },
                'style/color',
                'style/fontSize',
                'style/textTransform',
                {
                    path: 'icon/icon',
                    content: { label: 'Icon', template: 'IconSelect' },
                },
                {
                    path: 'icon/color',
                    content: {
                        label: 'Icon Color',
                        template: 'ColorPicker',
                    },
                },
                {
                    path: 'icon/size',
                    content: {
                        label: 'Icon Size',
                        template: 'Range',
                        defaultUnit: 'px',
                    },
                },
                {
                    path: 'icon/gap',
                    content: {
                        label: 'Icon & Text Gap',
                        template: 'Range',
                        defaultUnit: 'px',
                    },
                },
            ],
        },
        {
            hoverControl: false,
            label: 'Icon Alignment',
            modules: [
                {
                    path: 'style/flexDirection',
                    content: {
                        template: 'Tab',
                        defaultValue: '',
                        inputType: 'boxed',
                        label: 'Icon Position',
                        helpText: 'Icon position with the button text',
                        options: [
                            { label: 'Left', value: '' },
                            { label: 'Right', value: 'row-reverse' },
                            { label: 'Top', value: 'column' },
                        ],
                    },
                },
                {
                    path: 'style/alignItems',
                    conditions: ['style/flexDirection', '===', 'column'],
                    content: {
                        label: 'Horizontal Align',
                        options: [
                            { label: 'Left', value: 'flex-start' },
                            { label: 'Center', value: 'center' },
                            { label: 'Right', value: 'flex-end' },
                        ],
                    },
                },
                {
                    path: 'style/alignItems',
                    conditions: ['style/flexDirection', '!==', 'column'],
                    content: {
                        label: 'Vertical Align',
                        options: [
                            { label: 'Top', value: 'flex-start' },
                            { label: 'Middle', value: 'center' },
                            { label: 'Bottom', value: 'flex-end' },
                        ],
                    },
                },
                {
                    path: 'style/justifyContent',
                    content: { label: 'Horizontal Align', isResponsible: true },
                    conditions: [
                        ['style/flexDirection', '==', null],
                        '||',
                        ['style/flexDirection', '===', ''],
                    ],
                },
                {
                    path: 'style/justifyContent',
                    content: {
                        isResponsible: true,
                        label: 'Horizontal Align',
                        options: [
                            { label: 'Left', value: 'flex-end' },
                            { label: 'Center', value: 'center' },
                            { label: 'Right', value: 'flex-start' },
                        ],
                    },
                    conditions: ['style/flexDirection', '===', 'row-reverse'],
                },
            ],
        },
        {
            label: 'Background',
            modules: [
                {
                    path: 'settings/activeBgStyle',
                    content: {
                        visibleOn: ['normal', 'hover'],
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'color',
                        label: 'Background Style',
                        options: [
                            { label: 'Color', value: 'color' },
                            { label: 'Gradient', value: 'gradient' },
                        ],
                    },
                },
                ...backgroundStyles,
            ],
        },
    ],
    icon: [
        {
            hoverControl: false,
            label: 'Icon',
            modules: [
                {
                    path: 'icon/icon',
                    content: { label: 'Icon', template: 'IconSelect' },
                },
                {
                    path: 'icon/color',
                    content: {
                        label: 'Icon Color',
                        template: 'ColorPicker',
                    },
                },
                {
                    path: 'icon/size',
                    content: {
                        label: 'Icon Size',
                        template: 'Range',
                        defaultUnit: 'px',
                    },
                },
                'wrapper/textAlign',
            ],
        },
        {
            label: 'Icon Background',
            modules: [
                {
                    path: 'settings/activeBgStyle',
                    content: {
                        visibleOn: ['normal', 'hover'],
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'color',
                        label: 'Background Style',
                        options: [
                            { label: 'Color', value: 'color' },
                            { label: 'Gradient', value: 'gradient' },
                        ],
                    },
                },
                ...backgroundStyles,
            ],
        },
        {
            label: 'Link Icon',
            hoverControl: false,
            modules: ['attr/href', 'attr/target'],
        },
    ],

    button: [
        {
            label: 'Button Type & Contents',
            modules: [
                {
                    path: 'content',
                    content: {
                        template: 'Input',
                        label: 'Button Text',
                        inputType: 'input',
                    },
                },
                {
                    path: 'style/width',
                    content: {
                        onLabel: 'ON',
                        offLabel: 'OFF',
                        onValue: '100%',
                        offValue: 'auto',
                        template: 'Switch',
                        isResponsible: true,
                        defaultValue: 'auto',
                        label: 'Full Width Button',
                    },
                },
                {
                    path: 'style/justifyContent',
                    content: {
                        label: 'Text Align',
                        isResponsible: true,
                    },
                    conditions: [
                        ['style/width', '!=', null],
                        '&&',
                        ['style/width', '!==', 'auto'],
                    ],
                },
                {
                    path: 'wrapper/textAlign',
                    conditions: [
                        ['style/width', '===', 'auto'],
                        '||',
                        ['style/width', '==', null],
                    ],
                },
                {
                    path: 'style/color',
                    conditions: ['settings/buttonType', '!==', 'icon-only'],
                },
                {
                    path: 'style/fontSize',
                    conditions: ['settings/buttonType', '!==', 'icon-only'],
                },
                {
                    path: 'style/fontWeight',
                    conditions: ['settings/buttonType', '!==', 'icon-only'],
                },
                {
                    hoverable: false,
                    isResponsible: true,
                    template: 'FontSpaceLH',
                    conditions: ['settings/buttonType', '!==', 'icon-only'],
                    modules: ['style/lineHeight', 'style/letterSpacing'],
                },
                {
                    path: 'style/textTransform',
                    conditions: ['settings/buttonType', '!==', 'icon-only'],
                },
                {
                    path: 'settings/buttonType',
                    content: {
                        offValue: 'text-only',
                        onLabel: 'ON',
                        offLabel: 'OFF',
                        defaultValue: 'text-only',
                        template: 'Switch',
                        onValue: 'icon-text',
                        label: 'Button Icon',
                    },
                },
                {
                    path: 'icon/icon',
                    conditions: [
                        ['settings/buttonType', '!=', null],
                        '&&',
                        ['settings/buttonType', '!==', 'text-only'],
                    ],
                    content: {
                        label: 'Button Icon',
                        template: 'IconSelect',
                    },
                },
                // {
                //     path: "icon/relation",
                //     conditions: [
                //         ["settings/buttonType", "!=", null],
                //         "&&",
                //         ["settings/buttonType", "===", "icon-text"]
                //     ],
                //     content: {
                //         template: "Tab",
                //         label: "Icon Type",
                //         inputType: "boxed",
                //         defaultValue: "inline",
                //         helpText: "Icon relation to the button",
                //         options: [
                //             { label: "Inline with Text", value: "inline" },
                //             { label: "On the Side", value: "side" }
                //         ]
                //     }
                // },
                {
                    path: 'icon/size',
                    content: {
                        label: 'Icon Size',
                        template: 'Range',
                        defaultUnit: 'px',
                    },
                    conditions: [
                        ['settings/buttonType', '!=', null],
                        '&&',
                        ['settings/buttonType', '!==', 'text-only'],
                    ],
                },
                {
                    path: 'icon/gap',
                    content: {
                        label: 'Icon & Text Gap',
                        template: 'Range',
                        defaultUnit: 'px',
                    },
                    conditions: [
                        ['settings/buttonType', '!=', null],
                        '&&',
                        ['settings/buttonType', '===', 'icon-text'],
                    ],
                },
                {
                    path: 'style/flexDirection',
                    conditions: ['settings/buttonType', '===', 'icon-text'],
                    content: {
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: '',
                        label: 'Icon Position',
                        helpText: 'Icon position with the button text',
                        options: [
                            { label: 'Left Side of Text', value: '' },
                            {
                                label: 'Right Side of Text',
                                value: 'row-reverse',
                            },
                        ],
                    },
                },
                {
                    path: 'icon/color',
                    conditions: [
                        ['settings/buttonType', '!=', null],
                        '&&',
                        ['settings/buttonType', '!==', 'text-only'],
                    ],
                    content: {
                        hoverable: true,
                        label: 'Icon Color',
                        template: 'ColorPicker',
                    },
                },
                {
                    path: 'style/textShadow/_enabled',
                    conditions: ['settings/buttonType', '!==', 'icon-only'],
                },
                {
                    modules: [
                        {
                            hoverable: true,
                            isResponsible: true,
                            label: 'Shadow Offset & Blur',
                            modules: [
                                'style/textShadow/x',
                                'style/textShadow/y',
                                'style/textShadow/blur',
                            ],
                        },
                        'style/textShadow/color',
                    ],
                    conditions: [
                        ['settings/buttonType', '!==', 'icon-only'],
                        '&&',
                        ['style/textShadow/_enabled', '===', true],
                    ],
                },
            ],
        },
        {
            hoverControl: false,
            label: 'Button Link',
            modules: [
                {
                    path: 'attr/href',
                    content: {
                        label: 'Button URL',
                        template: 'Input',
                    },
                },
                'attr/target',
            ],
        },
        {
            label: 'Button Background',
            modules: [
                {
                    path: 'settings/activeBgStyle',
                    content: {
                        visibleOn: ['normal', 'hover'],
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'color',
                        label: 'Background Style',
                        options: [
                            { label: 'Color', value: 'color' },
                            { label: 'Gradient', value: 'gradient' },
                        ],
                    },
                },
                ...backgroundStyles,
            ],
        },
        {
            hoverControl: false,
            label: 'Inline Button',
            modules: [
                {
                    path: 'settings/inlineButton',
                    content: {
                        onValue: true,
                        onLabel: 'ON',
                        offValue: false,
                        offLabel: 'OFF',
                        template: 'Switch',
                        defaultValue: false,
                        label: 'Inline Button with Other Buttons',
                    },
                },
            ],
        },
    ],
    counterdown: [
        {
            hoverControl: false,
            label: 'End Date & Time',
            modules: [
                {
                    hoverControl: false,
                    modules: ['counter/date', 'counter/time'],
                },
                {
                    path: 'counter/GMT',
                    content: {
                        label: 'Timezone',
                        template: 'Select',
                        options: timeZone,
                    },
                },
                // MARK: Text When Finish
                {
                    path: 'counter/finishText',
                    content: {
                        template: 'Input',
                        label: 'Text When Finished',
                        inputType: 'input',
                    },
                },
            ],
        },
        {
            hoverControl: false,
            label: 'Timer Options',
            modules: [
                {
                    hoverControl: false,
                    modules: [
                        'counter/countStyle/fontSize',
                        'counter/countStyle/color',
                    ],
                },
                // MARK: counter text
                {
                    hoverControl: false,
                    group: true,
                    label: 'Counter Text',
                    modules: [
                        {
                            path: 'counter/text/days',
                            content: {
                                template: 'Input',
                                label: 'Days Text',
                                inputType: 'input',
                            },
                        },
                        {
                            path: 'counter/text/hours',
                            content: {
                                template: 'Input',
                                label: 'Hours Text',
                                inputType: 'input',
                            },
                        },
                        {
                            path: 'counter/text/minutes',
                            content: {
                                template: 'Input',
                                label: 'Minutes Text',
                                inputType: 'input',
                            },
                        },
                        {
                            path: 'counter/text/seconds',
                            content: {
                                template: 'Input',
                                label: 'Seconds Text',
                                inputType: 'input',
                            },
                        },
                        'counter/textStyle/fontSize',
                        'counter/textStyle/color',
                    ],
                },
                // MARK: counter separator
                {
                    hoverControl: false,
                    group: true,
                    label: 'Counter Separator',
                    modules: [
                        {
                            path: 'counter/settings/style',
                            content: {
                                template: 'Tab',
                                defaultValue: 'colon',
                                inputType: 'boxed',
                                label: 'Style',
                                options: [
                                    { label: 'Colon', value: 'colon' },
                                    { label: 'Line', value: 'line' },
                                    { label: 'None', value: 'none' },
                                ],
                            },
                        },
                        {
                            path: 'counter/separatorStyle/bgColor',
                            content: {
                                hoverable: true,
                                label: 'Color',
                                template: 'ColorPicker',
                            },
                        },
                        {
                            path: 'counter/separatorStyle/line/width',
                            content: {
                                isResponsible: true,
                                min: 10,
                                max: 100,
                                label: 'Width',
                                template: 'Range',
                                defaultUnit: 'px',
                            },
                            conditions: [
                                'counter/settings/style',
                                '===',
                                'line',
                            ],
                        },
                        {
                            path: 'counter/separatorStyle/line/height',
                            content: {
                                isResponsible: true,
                                min: 10,
                                max: 100,
                                label: 'Height',
                                template: 'Range',
                                defaultUnit: 'px',
                            },
                            conditions: [
                                'counter/settings/style',
                                '===',
                                'line',
                            ],
                        },
                        {
                            path: 'counter/separatorStyle/colon/fontSize',
                            content: {
                                isResponsible: true,
                                min: 10,
                                max: 100,
                                label: 'Separator Size',
                                template: 'Range',
                                defaultUnit: 'px',
                            },
                            conditions: [
                                'counter/settings/style',
                                '===',
                                'colon',
                            ],
                        },
                    ],
                },
            ],
        },
        // MARK: counter style
        {
            label: 'Counter Style',
            hoverControl: false,
            modules: [
                'style/width',
                {
                    path: 'counter/align',
                    content: {
                        label: 'Alignment',
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'left',
                        options: [
                            {
                                label: 'Left',
                                value: 'left',
                                icon: 'far align-left',
                            },
                            {
                                label: 'Center',
                                value: 'center',
                                icon: 'far align-center',
                            },
                            {
                                label: 'Right',
                                value: 'right',
                                icon: 'far align-right',
                            },
                        ],
                    },
                },
                {
                    path: 'counter/counterWrapperStyle/flexDirection',
                    content: {
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'row',
                        label: 'Text Position',
                        options: [
                            { label: 'Inline', value: 'row' },
                            { label: 'Below', value: 'column' },
                        ],
                    },
                },
                {
                    path: 'counter/settings/zero',
                    content: {
                        offValue: 'without-zero',
                        onLabel: 'ON',
                        offLabel: 'OFF',
                        defaultValue: 'without-zero',
                        template: 'Switch',
                        onValue: 'with-zero',
                        label: 'Leading Zero',
                    },
                },
                {
                    path: 'counter/settings/onlyHours',
                    content: {
                        offValue: 'days-hours',
                        onLabel: 'ON',
                        offLabel: 'OFF',
                        defaultValue: 'days-hours',
                        template: 'Switch',
                        onValue: 'only-hours',
                        label: 'Hide Days',
                    },
                },
            ],
        },
        // MARK: counter background
        {
            label: 'Background',
            hoverControl: false,
            modules: [
                {
                    path: 'settings/activeBgStyle',
                    content: {
                        visibleOn: ['normal', 'hover'],
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'color',
                        label: 'Background Style',
                        options: [
                            { label: 'Color', value: 'color' },
                            { label: 'Gradient', value: 'gradient' },
                        ],
                    },
                },
                ...backgroundStyles,
            ],
        },
    ],
    image: [
        {
            hoverControl: false,
            label: 'Image Options',
            modules: [
                {
                    path: 'attr/src',
                    content: { label: 'Image', template: 'ImagePreview' },
                },
                'attr/alt',
                'wrapper/textAlign',
                {
                    path: 'wrapper/type',
                    content: {
                        template: 'Tab',
                        defaultValue: '',
                        inputType: 'boxed',
                        label: 'Image Link URL',
                        options: [
                            { label: 'None', value: '' },
                            { label: 'Link', value: 'link' },
                            // { label: 'Lightbox', value: 'lightbox' },
                            { label: 'Image File', value: 'img-file' },
                        ],
                    },
                },
                {
                    path: 'wrapper/attr/href',
                    content: { template: 'Input' },
                    conditions: ['wrapper/type', '===', 'link'],
                },
                {
                    path: 'wrapper/attr/target',
                    conditions: [
                        ['wrapper/type', '===', 'link'],
                        '||',
                        ['wrapper/type', '===', 'img-file'],
                    ],
                },
                // {
                //     path: 'settings/style/filter/dropShadow',
                //     content: {
                //         onValue: true,
                //         onLabel: 'ON',
                //         offValue: false,
                //         offLabel: 'OFF',
                //         template: 'Switch',
                //         defaultValue: false,
                //         label: 'Image Drop Shadow',
                //     },
                // },
                // {
                //     path: 'style/filter/dropShadow',
                //     conditions: [
                //         'settings/style/filter/dropShadow',
                //         '===',
                //         true,
                //     ],
                // },
            ],
        },
        {
            hoverControl: false,
            label: 'Image Width & Height',
            modules: [
                {
                    path: 'style/width',
                    content: { defaultUnit: 'px', min: 100, max: 1600 },
                },
                {
                    path: 'style/height',
                    content: { defaultUnit: 'px', min: 100, max: 1500 },
                },
                'style/objectFit',
                {
                    path: 'style/objectPosition',
                    conditions: [
                        ['style/objectFit', '===', 'cover'],
                        '||',
                        ['style/objectFit', '==', undefined],
                    ],
                },
                {
                    path: 'style/objectPosition',
                    conditions: ['style/objectFit', '===', 'contain'],
                    content: {
                        options: [
                            { name: 'Center', value: '' },
                            { name: 'Top', value: 'top' },
                            { name: 'Bottom', value: 'bottom' },
                        ],
                    },
                },
                {
                    group: true,
                    label: 'Advanced',
                    modules: [
                        'style/minWidth',
                        'style/maxWidth',
                        'style/minHeight',
                        'style/maxHeight',
                    ],
                },
            ],
        },
        {
            label: 'Filters',
            modules: [
                {
                    hoverable: true,
                    label: 'Color Filters',
                    modules: [
                        'style/filter/hue-rotate',
                        'style/filter/saturate',
                        'style/filter/brightness',
                        'style/filter/contrast',
                        'style/filter/sepia',
                        'style/filter/grayscale',
                        'style/filter/invert',
                    ],
                },
                'style/filter/opacity',
                'style/filter/blur',
            ],
        },
        {
            hoverControl: false,
            label: 'Background of Image',
            modules: ['settings/activeBgStyle', ...backgroundStyles],
        },
    ],
    video: [
        {
            hoverControl: false,
            label: 'Video Options',
            modules: [
                {
                    path: 'settings/type',
                    content: {
                        template: 'Select',
                        options: [
                            { name: 'Upload', value: 'upload' },
                            { name: 'Embed', value: 'embed' },
                        ],
                    },
                },
                {
                    conditions: ['settings/type', '!==', 'embed'],
                    modules: [
                        {
                            path: 'sources/mp4',
                            content: {
                                size: 16,
                                label: 'MP4 Video',
                                accept: 'video/mp4',
                                template: 'ImagePreview',
                                addButtonText: 'Upload New Video',
                            },
                        },
                        {
                            path: 'sources/webm',
                            content: {
                                size: 16,
                                accept: 'video/webm',
                                label: 'WEBM Video',
                                template: 'ImagePreview',
                                addButtonText: 'Upload New Video',
                            },
                        },
                        'attr/poster',
                    ],
                },
                {
                    conditions: ['settings/type', '===', 'embed'],
                    modules: [
                        {
                            path: 'settings/url',
                            content: {
                                template: 'Input',
                                label: 'Video URL',
                                placeholder:
                                    'eg: https://youtube.com/watch?v=3ezCeWNsUJw',
                            },
                        },
                        {
                            path: 'none',
                            content: {
                                template: 'HelpText',
                                label: 'Acceptable URL formats:',
                                message: `<p style="font-size: 13px;font-size: 13px;margin-top: -5px;">
                                    https://www.youtube.com/watch?v=xxxxxx<br/>
                                    https://www.youtube.com/embed/xxxxxx<br/>
                                    https://www.youtu.be/watch?v=xxxxxx<br/>
                                    https://vimeo.com/xxxxxx</p>`,
                            },
                        },
                    ],
                },
            ],
        },
        {
            hoverControl: false,
            label: 'Player Configuration',
            modules: [
                'attr/controls',
                'attr/loop',
                'attr/muted',
                'attr/autoplay',
                'attr/fullscreen',
            ],
        },
        {
            hoverControl: false,
            label: 'Video Width & Height',
            modules: [
                'style/maxWidth',
                'style/width',
                'wrapper/textAlign',
                'style/minHeight',
                'style/height',
                'style/maxHeight',
            ],
        },
    ],
    line: [
        {
            hoverControl: false,
            label: 'Line Width & Height',
            modules: [
                'style/width',
                { path: 'style/height', content: { min: 0, max: 50 } },
                'wrapper/textAlign',
            ],
        },
        {
            label: 'Line Background',
            modules: [
                {
                    path: 'settings/activeBgStyle',
                    content: {
                        visibleOn: ['normal', 'hover'],
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'color',
                        label: 'Background Style',
                        options: [
                            { label: 'Color', value: 'color' },
                            { label: 'Gradient', value: 'gradient' },
                        ],
                    },
                },
                ...backgroundStyles,
            ],
        },
    ],
    subscription: [
        {
            hoverControl: false,
            label: 'Form Configuration',
            modules: [
                {
                    path: 'settings/service',
                    dependentsValue: {
                        'settings/webhook': '',
                    },
                },
                {
                    conditions: ['settings/service', '===', 'sendinblue'],
                    modules: [
                        {
                            path: 'settings/webhook',
                            content: {
                                label: 'Sendinblue Action URL',
                                template: 'Input',
                                brief:
                                    '[How to configure Sendinblue](https://help.dorik.io/style-and-editing/elements/subscription-form/sendinblue-configuration)',
                            },
                        },
                    ],
                },
                {
                    conditions: ['settings/service', '===', 'convertkit'],
                    modules: [
                        {
                            path: 'settings/webhook',
                            content: {
                                label: 'ConvertKit Action URL',
                                template: 'Input',
                                brief:
                                    '[How to configure ConvertKit](https://help.dorik.io/style-and-editing/elements/subscription-form/convertkit-configuration)',
                            },
                        },
                    ],
                },
                {
                    conditions: ['settings/service', '===', 'mailchimp'],
                    modules: [
                        {
                            path: 'settings/webhook',
                            content: {
                                label: 'MailChimp Action URL',
                                template: 'Input',
                                brief:
                                    '[How to configure mailchimp](https://help.dorik.io/style-and-editing/elements/subscription-form/mailchimp-configuration)',
                            },
                        },
                    ],
                },
                {
                    conditions: ['settings/service', '===', 'emailoctopus'],
                    modules: [
                        {
                            path: 'settings/webhook',
                            content: {
                                label: 'EmailOctopus Action URL',
                                template: 'Input',
                                brief:
                                    '[How to configure EmailOctopus](https://help.dorik.io/style-and-editing/elements/subscription-form/emailoctopus-configuration)',
                            },
                        },
                    ],
                },
                {
                    conditions: ['settings/service', '===', 'mailerlite'],
                    modules: [
                        {
                            path: 'settings/webhook',
                            content: {
                                template: 'Input',
                                label: 'Mailerlite Form ID',
                                brief:
                                    '[How to configure Mailerlite](https://help.dorik.io/style-and-editing/elements/subscription-form/mailerlite-configuration)',
                            },
                        },
                    ],
                },
                {
                    conditions: ['settings/service', '===', 'activecampaign'],
                    modules: [
                        {
                            path: 'settings/webhook',
                            content: {
                                template: 'Input',
                                label: 'ActiveCampaign URL',
                                brief:
                                    '[How to configure ActiveCampaign](https://help.dorik.io/style-and-editing/elements/subscription-form/activecampaign-configuration)',
                            },
                        },
                    ],
                },
                {
                    conditions: ['settings/service', '===', 'zapier'],
                    modules: [
                        {
                            path: 'settings/webhook',
                            content: {
                                template: 'Input',
                                label: 'Webhook URL',
                                placeholder:
                                    'https://hooks.zapier.com/hooks/catch/xxxxx/xxxxxx/',
                            },
                        },
                        {
                            template: 'WebhookHelp',
                        },
                    ],
                },
                {
                    conditions: ['settings/service', '===', 'pabbly'],
                    modules: [
                        {
                            path: 'settings/webhook',
                            content: {
                                template: 'Input',
                                label: 'Webhook URL',
                                placeholder:
                                    'https://connect.pabbly.com/workflow/sendwebhookdata/xxxxxx',
                            },
                        },
                        {
                            template: 'WebhookHelp',
                        },
                    ],
                },
                {
                    conditions: ['settings/service', '===', 'integromat'],
                    modules: [
                        {
                            path: 'settings/webhook',
                            content: {
                                template: 'Input',
                                label: 'Webhook URL',
                                placeholder:
                                    'https://hook.integromat.com/xxxxxx.....',
                            },
                        },
                        {
                            template: 'WebhookHelp',
                            content: {
                                message: 'test data',
                            },
                        },
                    ],
                },
                {
                    path: 'form/successAction',
                    content: {
                        label: 'Success Action',
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'message',
                        options: [
                            { label: 'Show Message', value: 'message' },
                            { label: 'Forward to URL', value: 'forward' },
                        ],
                    },
                },
                {
                    conditions: [
                        ['form/successAction', '===', 'message'],
                        '||',
                        ['form/successAction', '==', null],
                    ],
                    path: 'form/successMessage',
                    content: { label: 'Success Message', template: 'Input' },
                },
                {
                    conditions: ['form/successAction', '===', 'forward'],
                    path: 'form/forwardTo',
                    content: {
                        label: 'URL',
                        template: 'Input',
                        placeholder: 'http://example.com/thank-you',
                        info: 'URL should start with http',
                    },
                },
            ],
        },
        {
            hoverControl: false,
            label: 'Fields',
            modules: [
                {
                    group: true,
                    label: 'Email Field',
                    modules: [
                        {
                            path: 'fields/email/label',
                            content: {
                                template: 'Input',
                                label: 'Label',
                                placeholder: 'Label Text',
                            },
                        },
                        {
                            path: 'fields/email/attr/placeholder',
                            content: {
                                template: 'Input',
                                label: 'Placeholder',
                                placeholder: 'Placeholder Text',
                            },
                        },
                    ],
                },
                {
                    group: true,
                    label: 'Name Fields',
                    modules: [
                        {
                            path: 'fields/firstName/_enabled',
                            content: {
                                onLabel: 'ON',
                                offLabel: 'OFF',
                                onValue: true,
                                offValue: false,
                                template: 'Switch',
                                defaultValue: false,
                                label: 'First Name',
                            },
                        },
                        {
                            conditions: [
                                'fields/firstName/_enabled',
                                '===',
                                true,
                            ],
                            modules: [
                                {
                                    path: 'fields/firstName/label',
                                    content: {
                                        template: 'Input',
                                        label: 'Label',
                                        placeholder: 'Label Text',
                                    },
                                },
                                {
                                    path: 'fields/firstName/attr/placeholder',
                                    content: {
                                        template: 'Input',
                                        label: 'Placeholder',
                                        placeholder: 'Placeholder Text',
                                    },
                                },
                            ],
                        },
                        {
                            path: 'fields/lastName/_enabled',
                            content: {
                                onLabel: 'ON',
                                offLabel: 'OFF',
                                onValue: true,
                                offValue: false,
                                template: 'Switch',
                                label: 'Last Name',
                                defaultValue: false,
                            },
                        },
                        {
                            conditions: [
                                'fields/lastName/_enabled',
                                '===',
                                true,
                            ],
                            modules: [
                                {
                                    path: 'fields/lastName/label',
                                    content: {
                                        template: 'Input',
                                        label: 'Label',
                                        placeholder: 'Label Text',
                                    },
                                },
                                {
                                    path: 'fields/lastName/attr/placeholder',
                                    content: {
                                        template: 'Input',
                                        label: 'Placeholder',
                                        placeholder: 'Placeholder Text',
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            label: 'Form Style',
            hoverControl: false,
            modules: [
                {
                    path: 'form/type',
                    content: {
                        template: 'Tab',
                        inputType: 'boxed',
                        label: 'Form Direction',
                        defaultValue: 'horizontal',
                        options: [
                            { label: 'Horizontal', value: 'horizontal' },
                            { label: 'Vertical', value: 'vertical' },
                        ],
                    },
                },
                {
                    path: 'form/gap',
                    content: {
                        label: 'Gap Between Fields',
                        template: 'Range',
                        defaultUnit: 'px',
                    },
                },
                {
                    path: 'form/fieldsHeight',
                    content: {
                        defaultUnit: 'px',
                        template: 'Range',
                        label: 'Fileds and Button Height',
                    },
                },
                {
                    path: 'settings/activeBgStyle',
                    content: {
                        visibleOn: ['normal', 'hover'],
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'color',
                        label: 'Background Style',
                        options: [
                            { label: 'Color', value: 'color' },
                            { label: 'Gradient', value: 'gradient' },
                            { label: 'Image', value: 'image' },
                        ],
                    },
                },
                ...backgroundStyles,
            ],
        },
        {
            hoverControl: false,
            label: 'Input Label Style',
            modules: [
                'form/labelStyle/color',
                {
                    path: 'form/labelStyle/fontSize',
                    content: { isResponsible: false },
                },
                {
                    path: 'form/labelStyle/padding',
                    content: { isResponsible: false },
                },
            ],
        },
        {
            hoverControl: false,
            label: 'Input Field Style',
            modules: [
                'form/fieldStyle/color',
                {
                    path: 'form/fieldStyle/fontSize',
                    content: { isResponsible: false },
                },
                {
                    path: 'form/fieldStyle/padding',
                    content: { isResponsible: false },
                },
                {
                    group: true,
                    label: 'Border & Radius',
                    modules: [
                        'form/fieldStyle/_border',
                        {
                            path: 'form/fieldStyle/borderRadius',
                            content: { isResponsible: false },
                        },
                    ],
                },
                {
                    group: true,
                    label: 'Background',
                    modules: [
                        {
                            path: 'settings/activeBgStyle',
                            content: {
                                visibleOn: ['normal', 'hover'],
                                template: 'Tab',
                                inputType: 'boxed',
                                defaultValue: 'color',
                                label: 'Background Style',
                                options: [
                                    { label: 'Color', value: 'color' },
                                    { label: 'Gradient', value: 'gradient' },
                                ],
                            },
                        },
                        ...prefixBackgroundStyle('form/fieldStyle'),
                    ],
                },
            ],
        },
        {
            // hoverControl: false,
            label: 'Button Text & Style',
            modules: [
                {
                    path: 'form/button/content',
                    content: {
                        template: 'Input',
                        label: 'Button Text',
                        placeholder: 'Button Text',
                    },
                },
                'form/buttonStyle/color',
                {
                    path: 'form/buttonStyle/fontSize',
                    content: { isResponsible: false },
                },
                {
                    conditions: ['form/type', '===', 'vertical'],
                    path: 'form/buttonStyle/alignSelf',
                    content: {
                        label: 'Button Alignment',
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'flex-end',
                        options: [
                            { label: 'Left', value: 'flex-start' },
                            { label: 'Center', value: 'center' },
                            { label: 'Right', value: 'flex-end' },
                        ],
                    },
                },
                {
                    path: 'form/buttonStyle/padding',
                    content: { isResponsible: false },
                },
                {
                    group: true,
                    label: 'Border & Radius',
                    modules: [
                        'form/buttonStyle/_border',
                        {
                            path: 'form/buttonStyle/borderRadius',
                            content: { isResponsible: false },
                        },
                    ],
                },
                {
                    group: true,
                    label: 'Background',
                    modules: [
                        {
                            path: 'settings/activeBgStyle',
                            content: {
                                visibleOn: ['normal', 'hover'],
                                template: 'Tab',
                                inputType: 'boxed',
                                defaultValue: 'color',
                                label: 'Background Style',
                                options: [
                                    { label: 'Color', value: 'color' },
                                    { label: 'Gradient', value: 'gradient' },
                                ],
                            },
                        },
                        ...prefixBackgroundStyle('form/buttonStyle'),
                    ],
                },
            ],
        },
    ],
    contactForm: [
        {
            hoverControl: false,
            label: 'Form Configuration',
            isResponsible: false,
            modules: [
                {
                    path: 'settings/service',
                    dependentsValue: { 'settings/webhook': '' },
                    content: {
                        label: 'Send To',
                        options: [
                            { name: 'Email', value: 'email' },
                            { name: 'Zapier', value: 'zapier' },
                            { name: 'Integromat', value: 'integromat' },
                            { name: 'Pabbly Connect', value: 'pabbly' },
                        ],
                    },
                },
                {
                    conditions: [
                        ['settings/service', '===', 'email'],
                        '||',
                        ['settings/service', '==', null],
                    ],
                    path: 'form/toEmail',
                    content: {
                        label: 'Receive At',
                        template: 'Input',
                        placeholder: 'youremail@example.com',
                    },
                },
                {
                    conditions: ['settings/service', '===', 'zapier'],
                    modules: [
                        {
                            path: 'settings/webhook',
                            content: {
                                label: 'Webhook URL',
                                template: 'Input',
                                placeholder:
                                    'https://hooks.zapier.com/hooks/catch/xxxxx/xxxxxx/',
                            },
                        },
                        {
                            template: 'WebhookHelp',
                            content: {
                                message: 'test data',
                            },
                        },
                    ],
                },
                {
                    conditions: ['settings/service', '===', 'pabbly'],
                    modules: [
                        {
                            path: 'settings/webhook',
                            content: {
                                template: 'Input',
                                label: 'Webhook URL',
                                placeholder:
                                    'https://connect.pabbly.com/workflow/sendwebhookdata/xxxxxx',
                            },
                        },
                        {
                            template: 'WebhookHelp',
                        },
                    ],
                },
                {
                    conditions: ['settings/service', '===', 'integromat'],
                    modules: [
                        {
                            path: 'settings/webhook',
                            content: {
                                template: 'Input',
                                label: 'Webhook URL',
                                placeholder:
                                    'https://hook.integromat.com/xxxxxx.....',
                            },
                        },
                        {
                            template: 'WebhookHelp',
                            content: {
                                message: 'test data',
                            },
                        },
                    ],
                },
                {
                    path: 'form/successAction',
                    content: {
                        label: 'Success Action',
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'message',
                        options: [
                            { label: 'Show Message', value: 'message' },
                            { label: 'Forward to URL', value: 'forward' },
                        ],
                    },
                },
                {
                    conditions: [
                        ['form/successAction', '===', 'message'],
                        '||',
                        ['form/successAction', '==', null],
                    ],
                    path: 'form/successMessage',
                    content: { label: 'Success Message', template: 'Input' },
                },
                {
                    conditions: ['form/successAction', '===', 'forward'],
                    path: 'form/forwardTo',
                    content: {
                        label: 'URL',
                        template: 'Input',
                        placeholder: 'http://example.com/thank-you',
                        info: 'URL should start with http',
                    },
                },
            ],
        },
        {
            label: 'Fields',
            hoverControl: false,
            modules: [
                {
                    group: true,
                    label: 'Name',
                    modules: [
                        {
                            path: 'fields/name/_enabled',
                            content: {
                                onLabel: 'ON',
                                offLabel: 'OFF',
                                onValue: true,
                                offValue: false,
                                template: 'Switch',
                                defaultValue: false,
                            },
                        },
                        {
                            conditions: ['fields/name/_enabled', '===', true],
                            modules: [
                                {
                                    path: 'fields/name/label',
                                    content: {
                                        template: 'Input',
                                        label: 'Label',
                                        placeholder: 'Label Text',
                                    },
                                },
                                {
                                    path: 'fields/name/attr/placeholder',
                                    content: {
                                        template: 'Input',
                                        label: 'Placeholder',
                                        placeholder: 'Placeholder Text',
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    group: true,
                    label: 'Email',
                    modules: [
                        {
                            path: 'fields/email/label',
                            content: {
                                template: 'Input',
                                label: 'Label',
                                placeholder: 'Label Text',
                            },
                        },
                        {
                            path: 'fields/email/attr/placeholder',
                            content: {
                                template: 'Input',
                                label: 'Placeholder',
                                placeholder: 'Placeholder Text',
                            },
                        },
                    ],
                },
                {
                    group: true,
                    label: 'Phone',
                    modules: [
                        {
                            path: 'fields/phone/_enabled',
                            content: {
                                onLabel: 'ON',
                                offLabel: 'OFF',
                                onValue: true,
                                offValue: false,
                                template: 'Switch',
                                defaultValue: false,
                            },
                        },
                        {
                            conditions: ['fields/phone/_enabled', '===', true],
                            modules: [
                                {
                                    path: 'fields/phone/label',
                                    content: {
                                        template: 'Input',
                                        label: 'Label',
                                        placeholder: 'Label Text',
                                    },
                                },
                                {
                                    path: 'fields/phone/attr/placeholder',
                                    content: {
                                        template: 'Input',
                                        label: 'Placeholder',
                                        placeholder: 'Placeholder Text',
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    group: true,
                    label: 'Subject',
                    modules: [
                        {
                            path: 'fields/subject/_enabled',
                            content: {
                                onLabel: 'ON',
                                offLabel: 'OFF',
                                onValue: true,
                                offValue: false,
                                template: 'Switch',
                                defaultValue: false,
                            },
                        },
                        {
                            conditions: [
                                'fields/subject/_enabled',
                                '===',
                                true,
                            ],
                            modules: [
                                {
                                    path: 'fields/subject/label',
                                    content: {
                                        template: 'Input',
                                        label: 'Label',
                                        placeholder: 'Label Text',
                                    },
                                },
                                {
                                    path: 'fields/subject/attr/placeholder',
                                    content: {
                                        template: 'Input',
                                        label: 'Placeholder',
                                        placeholder: 'Placeholder Text',
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    group: true,
                    label: 'Message',
                    modules: [
                        {
                            path: 'fields/message/label',
                            content: {
                                template: 'Input',
                                label: 'Label',
                                placeholder: 'Label Text',
                            },
                        },
                        {
                            path: 'fields/message/attr/placeholder',
                            content: {
                                template: 'Input',
                                label: 'Placeholder',
                                placeholder: 'Placeholder Text',
                            },
                        },
                    ],
                },
            ],
        },
        {
            label: 'Form Style',
            hoverControl: false,
            modules: [
                {
                    path: 'form/gap',
                    content: {
                        label: 'Gap Between Fields',
                        template: 'Range',
                        defaultUnit: 'px',
                    },
                },
                {
                    path: 'settings/activeBgStyle',
                    content: {
                        visibleOn: ['normal', 'hover'],
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'color',
                        label: 'Background Style',
                        options: [
                            { label: 'Color', value: 'color' },
                            { label: 'Gradient', value: 'gradient' },
                            { label: 'Image', value: 'image' },
                        ],
                    },
                },
                ...backgroundStyles,
            ],
        },
        {
            hoverControl: false,
            label: 'Input Label Style',
            modules: [
                'form/labelStyle/color',
                {
                    path: 'form/labelStyle/fontSize',
                    content: { isResponsible: false },
                },
                {
                    path: 'form/labelStyle/padding',
                    content: { isResponsible: false },
                },
            ],
        },
        {
            hoverControl: false,
            label: 'Input Field Style',
            modules: [
                'form/fieldStyle/color',
                {
                    path: 'form/fieldStyle/fontSize',
                    content: { isResponsible: false },
                },
                {
                    path: 'form/fieldStyle/padding',
                    content: { isResponsible: false },
                },
                {
                    group: true,
                    label: 'Input Fields Height',
                    modules: [
                        {
                            path: 'form/fieldStyle/minHeight',
                            content: {
                                min: 30,
                                max: 150,
                                label: 'Height',
                                isResponsible: false,
                            },
                        },
                        {
                            path: 'fields/message/attr/rows',
                            content: {
                                min: 1,
                                max: 20,
                                template: 'Range',
                                allowedUnits: [''],
                                label: 'Message Textarea Height',
                            },
                        },
                    ],
                },
                {
                    group: true,
                    label: 'Border & Radius',
                    modules: [
                        'form/fieldStyle/_border',
                        {
                            path: 'form/fieldStyle/borderRadius',
                            content: { isResponsible: false },
                        },
                    ],
                },
                {
                    group: true,
                    label: 'Background',
                    modules: [
                        {
                            path: 'settings/activeBgStyle',
                            content: {
                                visibleOn: ['normal', 'hover'],
                                template: 'Tab',
                                inputType: 'boxed',
                                defaultValue: 'color',
                                label: 'Background Style',
                                options: [
                                    { label: 'Color', value: 'color' },
                                    { label: 'Gradient', value: 'gradient' },
                                ],
                            },
                        },
                        ...prefixBackgroundStyle('form/fieldStyle'),
                    ],
                },
            ],
        },
        {
            hoverControl: false,
            label: 'Button Text & Style',
            modules: [
                {
                    path: 'fields/button/text',
                    content: {
                        template: 'Input',
                        label: 'Button Text',
                        placeholder: 'Button Text',
                    },
                },
                'form/buttonStyle/color',
                {
                    path: 'form/buttonStyle/fontSize',
                    content: { isResponsible: false },
                },
                {
                    group: true,
                    label: 'Spacing & Alignment',
                    modules: [
                        {
                            path: 'form/buttonStyle/width',
                            content: {
                                onLabel: 'ON',
                                offLabel: 'OFF',
                                onValue: '100%',
                                offValue: 'auto',
                                template: 'Switch',
                                isResponsible: false,
                                defaultValue: 'auto',
                                label: 'Full Width Button',
                            },
                        },
                        {
                            conditions: [
                                'form/buttonStyle/width',
                                '!==',
                                '100%',
                            ],
                            path: 'form/buttonWrapperStyle/textAlign',
                            content: {
                                label: 'Button Alignment',
                                template: 'Tab',
                                inputType: 'boxed',
                                defaultValue: 'left',
                                options: [
                                    { label: 'Left', value: 'left' },
                                    { label: 'Center', value: 'center' },
                                    { label: 'Right', value: 'right' },
                                ],
                            },
                        },
                        {
                            conditions: [
                                'form/buttonStyle/width',
                                '===',
                                '100%',
                            ],
                            path: 'form/buttonStyle/textAlign',
                            content: {
                                isResponsible: false,
                                label: 'Text Alignment',
                                template: 'Tab',
                                inputType: 'boxed',
                                defaultValue: 'center',
                                options: [
                                    { label: 'Left', value: 'left' },
                                    { label: 'Center', value: 'center' },
                                    { label: 'Right', value: 'right' },
                                ],
                            },
                        },
                        {
                            path: 'form/buttonStyle/height',
                            content: {
                                min: 20,
                                max: 200,
                                isResponsible: false,
                            },
                        },
                        {
                            path: 'form/buttonStyle/padding',
                            content: { isResponsible: false },
                        },
                    ],
                },
                {
                    group: true,
                    label: 'Border & Radius',
                    modules: [
                        'form/buttonStyle/_border',
                        {
                            path: 'form/buttonStyle/borderRadius',
                            content: { isResponsible: false },
                        },
                    ],
                },
                {
                    group: true,
                    label: 'Background',
                    modules: [
                        {
                            path: 'settings/activeBgStyle',
                            content: {
                                visibleOn: ['normal', 'hover'],
                                template: 'Tab',
                                inputType: 'boxed',
                                defaultValue: 'color',
                                label: 'Background Style',
                                options: [
                                    { label: 'Color', value: 'color' },
                                    { label: 'Gradient', value: 'gradient' },
                                ],
                            },
                        },
                        ...prefixBackgroundStyle('form/buttonStyle'),
                    ],
                },
            ],
        },
    ],
    iframe: [
        {
            hoverControl: false,
            label: 'Iframe Content',
            modules: [
                {
                    path: 'attr/src',
                    content: {
                        label: 'Iframe URL',
                        template: 'Input',
                    },
                },
                {
                    path: 'attr/width',
                    content: { allowedUnits: [''], min: 100, max: 1280 },
                },
                {
                    path: 'attr/height',
                    content: { allowedUnits: [''], min: 50, max: 1280 },
                },
                {
                    path: 'settings/aspectRatio',
                    content: {
                        label: 'Aspect Ratio',
                        template: 'Select',
                        options: [
                            { name: 'Ignore', value: 'ignore' },
                            { name: 'Flexible', value: 'flexible' },
                        ],
                    },
                },
            ],
        },
        {
            hoverControl: false,
            label: 'Iframe Background',
            modules: [
                {
                    path: 'settings/activeBgStyle',
                    content: {
                        visibleOn: ['normal', 'hover'],
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'color',
                        label: 'Background Style',
                        options: [
                            { label: 'Color', value: 'color' },
                            { label: 'Gradient', value: 'gradient' },
                        ],
                    },
                },
                ...backgroundStyles,
            ],
        },
    ],
    code: [
        {
            label: 'Custom Code',
            membership: ['PLAN_1', 'PLAN_2', 'PLAN_3'],
            hoverControl: false,
            modules: [
                {
                    path: 'advanced/html',
                    content: {
                        template: 'CodeEditor',
                    },
                },
            ],
        },
    ],
    accordion: [
        {
            label: 'Accordions',
            hoverControl: false,
            modules: [
                {
                    path: 'accordions/items',
                    template: 'DraggableItems',
                    modules: [
                        {
                            key: 'label',
                            content: {
                                defaultValue: '',
                                label: 'Accordion Heading',
                                template: 'Input',
                            },
                        },
                        {
                            key: 'paragraph',
                            content: {
                                defaultValue: '',
                                label: 'Accordion Paragraph',
                                template: 'RichTextEditor',
                            },
                        },
                    ],
                },
            ],
        },
        {
            label: 'Accordion Styles',
            hoverControl: false,
            modules: [
                {
                    path: 'accordions/gap',
                    content: {
                        label: 'Accordion Gap',
                        defaultUnit: 'px',
                        template: 'Range',
                    },
                },
                {
                    group: true,
                    label: 'Border & Radius',
                    modules: [
                        'accordions/accordionsWrapperStyle/_border',
                        {
                            path:
                                'accordions/accordionsWrapperStyle/borderRadius',
                            content: { isResponsible: false },
                        },
                    ],
                },
                // {
                //     path: 'accordions/settings/activeBgStyle',
                //     content: {
                //         visibleOn: ['normal', 'hover'],
                //         template: 'Tab',
                //         inputType: 'boxed',
                //         defaultValue: 'color',
                //         label: 'Background Style',
                //         options: [
                //             { label: 'Color', value: 'color' },
                //             { label: 'Gradient', value: 'gradient' },
                //         ],
                //     },
                // },
                // ...coustomBackground(
                //     `accordions/accordionsWrapperStyle`,
                //     'accordions'
                // ),
                // mark: color
                {
                    group: true,
                    label: 'Background',
                    modules: [
                        {
                            path: 'settings/activeBgStyle',
                            content: {
                                visibleOn: ['normal', 'hover'],
                                template: 'Tab',
                                inputType: 'boxed',
                                defaultValue: 'color',
                                label: 'Background Style',
                                options: [
                                    { label: 'Color', value: 'color' },
                                    { label: 'Gradient', value: 'gradient' },
                                ],
                            },
                        },
                        ...prefixBackgroundStyle(
                            'accordions/accordionsWrapperStyle'
                        ),
                    ],
                },
            ],
        },
        {
            label: 'Heading Styles',
            hoverControl: false,
            modules: [
                {
                    path: 'accordions/headingStyle/fontSize',
                    content: { label: 'Heading Size' },
                },
                'accordions/headingStyle/color',
                'accordions/headingStyle/fontWeight',
                {
                    hoverable: false,
                    isResponsible: true,
                    label: 'Spacing & Line Height',
                    template: 'FontSpaceLH',
                    modules: [
                        'accordions/headingStyle/lineHeight',
                        'accordions/headingStyle/letterSpacing',
                    ],
                },
                'accordions/headingStyle/padding',
                {
                    group: true,
                    label: 'Background',
                    modules: [
                        {
                            path: 'settings/activeBgStyle',
                            content: {
                                visibleOn: ['normal', 'hover'],
                                template: 'Tab',
                                inputType: 'boxed',
                                defaultValue: 'color',
                                label: 'Background Style',
                                options: [
                                    { label: 'Color', value: 'color' },
                                    { label: 'Gradient', value: 'gradient' },
                                ],
                            },
                        },
                        ...prefixBackgroundStyle('accordions/headingStyle'),
                    ],
                },
            ],
        },
        {
            label: 'Content Styles',
            hoverControl: false,
            modules: [
                {
                    path: 'accordions/paragraphStyle/fontSize',
                    content: { label: 'Text Size' },
                },
                'accordions/paragraphStyle/color',
                {
                    hoverable: false,
                    isResponsible: true,
                    label: 'Spacing & Line Height',
                    template: 'FontSpaceLH',
                    modules: [
                        'accordions/paragraphStyle/lineHeight',
                        'accordions/paragraphStyle/letterSpacing',
                    ],
                },
                'accordions/paragraphStyle/padding',
            ],
        },
        {
            label: 'Background',
            modules: [
                {
                    path: 'settings/activeBgStyle',
                    content: {
                        visibleOn: ['normal', 'hover'],
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'color',
                        label: 'Background Style',
                        options: [
                            { label: 'Color', value: 'color' },
                            { label: 'Gradient', value: 'gradient' },
                            { label: 'Image', value: 'image' },
                        ],
                    },
                },
                ...backgroundStyles,
            ],
        },
    ],
    links: [
        {
            label: 'Link Items',
            hoverControl: false,
            modules: [
                {
                    path: 'links/items',
                    template: 'DraggableItems',
                    modules: [
                        {
                            key: 'label',
                            content: {
                                defaultValue: '',
                                label: 'Link Text',
                                template: 'Input',
                            },
                        },
                        {
                            key: 'url',
                            content: {
                                label: 'URL',
                                defaultValue: '',
                                template: 'Input',
                                placeholder: 'http://example.com',
                            },
                        },
                        {
                            key: 'target',
                            content: {
                                template: 'Checkbox',
                                options: [
                                    {
                                        value: '_blank',
                                        label: 'Open in New Tab',
                                    },
                                ],
                            },
                        },
                        {
                            key: 'icon',
                            content: {
                                label: 'Link Icon',
                                template: 'IconSelect',
                            },
                        },
                    ],
                },
            ],
        },
        {
            label: 'Link Item Styles',
            modules: [
                {
                    path: 'style/flexDirection',
                    content: {
                        label: 'Links Direction',
                    },
                },
                {
                    path: 'links/gap',
                    content: {
                        label: 'Links Gap',
                    },
                },
                {
                    group: true,
                    label: 'Text',
                    modules: [
                        'links/style/fontSize',
                        {
                            hoverable: false,
                            isResponsible: true,
                            label: 'Spacing & Line Height',
                            template: 'FontSpaceLH',
                            modules: [
                                'links/style/lineHeight',
                                'links/style/letterSpacing',
                            ],
                        },
                        'links/style/color',
                        'links/align',
                        {
                            group: true,
                            label: 'Text Line',
                            modules: [
                                'links/style/textDecoration/type',
                                'links/style/textDecoration/style',
                                'links/style/textDecoration/color',
                            ],
                        },
                    ],
                },
                {
                    group: true,
                    label: 'Icon',
                    modules: ['links/icon/position', 'links/icon/gap'],
                },
            ],
        },
    ],
    nav: [
        {
            label: 'Logo',
            hoverControl: false,
            modules: [
                {
                    path: 'brand/logo',
                    content: {
                        accept: 'image/*',
                        label: 'Brand Logo',
                        template: 'ImagePreview',
                        addButtonText: 'Upload Logo',
                    },
                },
                {
                    path: 'brand/logoAlt',
                    content: {
                        label: 'Logo Alt',
                        template: 'Input',
                    },
                },
                {
                    path: 'brand/url',
                    content: {
                        label: 'URL',
                        template: 'Input',
                    },
                },
                {
                    path: 'brand/style/width',
                    content: {
                        max: 300,
                        label: 'Width',
                        defaultUnit: 'px',
                        template: 'Range',
                    },
                },
            ],
        },
        {
            label: 'Links',
            hoverControl: false,
            modules: [
                {
                    path: 'links/items',
                    template: 'DraggableItems',
                    modules: [
                        {
                            key: 'label',
                            content: {
                                defaultValue: '',
                                label: 'Link Text',
                                template: 'Input',
                            },
                        },
                        {
                            key: 'url',
                            content: {
                                label: 'URL',
                                defaultValue: '',
                                template: 'Input',
                                placeholder: 'http://example.com',
                            },
                        },
                        {
                            key: 'target',
                            content: {
                                template: 'Checkbox',
                                options: [
                                    {
                                        value: '_blank',
                                        label: 'Open in New Tab',
                                    },
                                ],
                            },
                        },
                        {
                            key: 'icon',
                            content: {
                                label: 'Link Icon',
                                template: 'IconSelect',
                            },
                        },
                        {
                            key: 'data',
                            content: {
                                label: 'Data Attributes',
                                template: 'DataAttributes',
                            },
                        },
                    ],
                },
            ],
        },
        {
            label: 'Links Style',
            modules: [
                'links/align',
                {
                    path: 'links/gap',
                    content: {
                        label: 'Gap Between Links',
                    },
                },
                {
                    group: true,
                    label: 'Text',
                    modules: [
                        'links/style/fontSize',
                        'links/style/color',
                        {
                            hoverable: false,
                            isResponsible: true,
                            label: 'Spacing & Line Height',
                            template: 'FontSpaceLH',
                            modules: [
                                'links/style/lineHeight',
                                'links/style/letterSpacing',
                            ],
                        },
                        {
                            group: true,
                            label: 'Text Line',
                            modules: [
                                'links/style/textDecoration/type',
                                'links/style/textDecoration/style',
                                'links/style/textDecoration/color',
                            ],
                        },
                    ],
                },
                {
                    group: true,
                    label: 'Icon',
                    modules: ['links/icon/position', 'links/icon/gap'],
                },
            ],
        },
        {
            label: 'Buttons',
            hoverControl: false,
            modules: [
                {
                    path: 'btn/items',
                    template: 'DraggableItems',
                    modules: [
                        {
                            key: 'label',
                            content: {
                                defaultValue: '',
                                label: 'Button Text',
                                template: 'Input',
                            },
                        },
                        {
                            key: 'url',
                            content: {
                                label: 'URL',
                                defaultValue: '',
                                template: 'Input',
                                placeholder: 'http://example.com',
                            },
                        },
                        {
                            key: 'target',
                            content: {
                                template: 'Checkbox',
                                options: [
                                    {
                                        value: '_blank',
                                        label: 'Open in New Tab',
                                    },
                                ],
                            },
                        },
                        {
                            key: 'icon',
                            content: {
                                label: 'Link Icon',
                                template: 'IconSelect',
                            },
                        },
                        {
                            key: 'style/color',
                            content: {
                                label: 'Text Color',
                                template: 'ColorPicker',
                            },
                        },
                        {
                            key: 'style/backgroundColor',
                            content: {
                                label: 'Background',
                                template: 'ColorPicker',
                            },
                        },
                        {
                            key: 'style/_border',
                            content: {
                                template: 'SimpleBorder',
                            },
                        },
                        {
                            key: 'data',
                            content: {
                                label: 'Data Attributes',
                                template: 'DataAttributes',
                            },
                        },
                    ],
                },
            ],
        },
        {
            hoverControl: false,
            label: 'Buttons Style',
            modules: [
                {
                    path: 'btn/gap',
                    content: {
                        label: 'Gap Between Buttons',
                    },
                },
                {
                    group: true,
                    label: 'Text',
                    modules: [
                        'btn/style/fontSize',
                        'btn/style/fontWeight',
                        {
                            hoverable: false,
                            isResponsible: true,
                            label: 'Spacing & Line Height',
                            template: 'FontSpaceLH',
                            modules: [
                                'btn/style/lineHeight',
                                'btn/style/letterSpacing',
                            ],
                        },
                        'btn/style/padding',
                        'btn/style/borderRadius',
                    ],
                },
                {
                    group: true,
                    label: 'Icon',
                    modules: ['btn/icon/position', 'btn/icon/gap'],
                },
            ],
        },
        {
            label: 'Toggle',
            hoverControl: false,
            modules: [
                {
                    path: 'toggle/text',
                    content: {
                        template: 'Input',
                        label: 'Button Text',
                    },
                },
                {
                    path: 'toggle/style/fontSize',
                    content: { label: 'Icon Size' },
                },
                'toggle/style/color',
                'toggle/style/backgroundColor',
                'toggle/style/_border',
                {
                    path: 'toggle/style/padding',
                    content: { isResponsible: false },
                },
                {
                    path: 'toggle/style/borderRadius',
                    content: { isResponsible: false },
                },
            ],
        },
        {
            label: 'Settings & Background',
            hoverControl: false,
            modules: [
                {
                    path: 'settings/sticky',
                    content: {
                        onLabel: 'ON',
                        offLabel: 'OFF',
                        onValue: true,
                        offValue: false,
                        template: 'Switch',
                        defaultValue: false,
                        label: 'Sticky Navigation',
                    },
                },
                {
                    path: 'settings/stickyBG',
                    content: {
                        template: 'ColorPicker',
                        label: 'Sticky & Expend Background',
                    },
                },
            ],
        },
    ],
};
